/** @jsxImportSource @emotion/react */
import {CRUD_STATE} from '../../forms/elements/crudButtons/crudState';
import ellipsis from '../../assets/icons/ellipsisVerticalSolid.svg';
import {css, SerializedStyles} from '@emotion/react';
import {useEffect, useState} from 'react';
import {CLEAR_BUTTON} from '../../styles/styles';
import trashcan from '../../assets/icons/trashcan.svg';
import * as React from 'react';
import {LIGHT_GREEN, LIGHT_GREY, MIDDLE_GREY} from '../../styles/colors';
import {ToggleSwitchSmall} from '../../forms/elements/ToggleSwitchSmall';
import { getResource } from '../../language/resources/getResource';
import { useSelector } from 'react-redux';
import { IAppState } from '../../core/redux/IAppState';


const editMenuMain = (currentState) => css`
  position: relative;
  display: flex;
  align-items: center;
  visibility: ${currentState === CRUD_STATE.READING ? "visible" : "hidden"};
`;

const buttonRowMenuItem = css`
  display: flex;
  align-items: center;
  width: 150px;
  :hover {
    background-color: ${LIGHT_GREY};
  }
  gap: 10%;
  margin-bottom: 10px;
`;

const popupButtonMenu = (show) => css`
  visibility: ${show ? "visible" : "hidden"};
  position: absolute;
  top: 100%;
  left: -150%;
  transform: translateX(-50%);
  background-color: white;
  color: black;
  padding: 0.5rem;
  border: 1px solid #fff;
  border-radius: 0.5rem;
  z-index: 2;
  box-shadow: 2px 3px 5px #999;
`;

const resetPasswordCheckbox = css`
  width: 20px; 
  height: 20px; 
  cursor: pointer; 
  margin-left: 5px`

const editMenuMoreOptions = (show) => css`
  display: inline-block; 
  cursor: pointer; 
  ${show ? `background-color: #373A365C;` : ``}; 
  border-radius: 0.5rem`


type Props = {
  currentState: CRUD_STATE,
  onDelete: () => void,
  onBlock?: () => void,
  onUnblock?: () => void,
  rootCss?: SerializedStyles,
  blocked?: boolean,
  resetPassword?: boolean,
  handleResetPassword?: () => void,
}

export const EditMenu = (props : Props) => {
  const [show, setShow] = useState(false);
  const currentResources = useSelector((state: IAppState) => state.locale);

  useEffect(() => {
    if (props.currentState !== CRUD_STATE.READING) {
      setShow(false);
    }
  },[props.currentState, props.blocked]);


  const handleEnableDisable = (isEnable: boolean) => {
    if (props.onBlock === undefined || props.onUnblock === undefined) {
      return;
    }
    isEnable ? props.onUnblock() : props.onBlock();
  }

  const handleBlur = () => {
    setTimeout(() => {
      setShow(false);
    }, 250);
  }


  return (
    <div css={editMenuMain(props.currentState)}>
      <div css={popupButtonMenu(show)}>
        { // Buttons
           <div css={buttonRowMenuItem} title={props.blocked ? getResource(currentResources, 'USER_EDIT_MENU_ENABLE_USER_TITLE') : getResource(currentResources, 'USER_EDIT_MENU_DISABLE_USER_TITLE')}>
              <ToggleSwitchSmall
                isOn={!props.blocked || false}
                onToggle={handleEnableDisable}
                onColor={LIGHT_GREEN}
                offColor={MIDDLE_GREY}
                onText={''}
                offText={''}
              />
              <span>{props.blocked ? getResource(currentResources, 'USER_EDIT_MENU_ENABLE_USER') : getResource(currentResources, 'USER_EDIT_MENU_DISABLE_USER')}</span>
            </div>
        }

        <div css={buttonRowMenuItem} onClick={props.onDelete}>
          <button
            onClick={props.onDelete}
            css={CLEAR_BUTTON}
          >
            <img src={trashcan}
                 alt="Trashcan"
                 title={getResource(currentResources, 'USER_EDIT_MENU_DELETE_USER_TITLE')}
                 css={css`margin-left: -4px;`}
            />
          </button>
          <span>{getResource(currentResources, 'USER_EDIT_MENU_DELETE_USER_TITLE')}</span>
        </div>

        <div css={buttonRowMenuItem} >
          <input
            type="checkbox"
            checked={props.resetPassword}
            onChange={props.handleResetPassword}
            css={resetPasswordCheckbox}
          />
          <span>{getResource(currentResources, 'USER_EDIT_MENU_RESET_PASSWORD')}</span>
        </div>
        
      </div>
      <div
        onClick={() => setShow(!show)}
        css={editMenuMoreOptions(show)}
        title={getResource(currentResources, 'USER_EDIT_MENU_MORE_OPTIONS')}
      >
        <button
          onBlur={handleBlur}
          css={CLEAR_BUTTON}>
          <img src={ellipsis} alt=''/>
        </button>
      </div>
    </div>
  )
}